import { BackpackServiceError, isBackpackResponseErrorBody } from "../errors";

const ADDITIONAL_HELP_TEXT =
  "If the issue persists, please email support@backpacknetworks.com so we can help you resolve it.";

/**
 * Amends any server error message with additional help text
 * @param fallbackMessage message passed to error constructor if the server error is not a BackpackResponseErrorBody
 */
export const createThrowerWithHelpText =
  ({ fallbackMessage }: { fallbackMessage?: string } = {}) =>
  (error: any) => {
    const { message, code } = getErrorInfo(error, fallbackMessage);
    const formattedError = {
      error: {
        message: `Error: ${message}. ${ADDITIONAL_HELP_TEXT}`,
        code,
      },
    };
    throw new BackpackServiceError(formattedError);
  };

export const throwErrorWithHelpText = createThrowerWithHelpText();

function getErrorInfo(body: any, text?: string) {
  if (isBackpackResponseErrorBody(body)) {
    return { message: body.error.message, code: body.error.code };
  }

  const error = new Error(text ?? body);

  return {
    message: error.message || "An unexpected error occurred",
    code: undefined,
  };
}
